
<!-- user inputs ---------------------------------------------------------- -->
<div class="container-fluid" style="margin-bottom: 6em;">
    <div class="row">
        <div class="col">
            <h3>Reports</h3>
            <div class="center">
                <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
            </div>
        </div>
    </div>
    <div>
    <div class="ui-g">
       <div class="ui-g-3 ui-fluid">
            <div class="input-box">
            <p-radioButton id="radio-btn-lrn" name="reportsGroup" value="lrn" label="LRN" [(ngModel)]="reportType" ></p-radioButton>
            </div>
       </div>
    </div>
    </div>
    <div>
        <!-- input Code -->
        <div class="ui-g">
            <div class="ui-g-3 ui-fluid">
                <div class="input-box">

                    <p-inputMask #codeMask
                        inputId="input-code"
                        (onComplete)="doComplete('input-code')"
                        [(ngModel)]="lrn"
                        [autoClear]="false"
                        mask="a99-999-9999"
                        characterPattern="[2-9]"
                        placeholder="xxx-xxx-xxxx"
                        ></p-inputMask>

                </div>
               
            </div>
            <div class="ui-g-x">
                <div class="input-box">
                    <button id="btn-export-csv" type="button" [class]="'width-150px btn ' + getBtnExportCsvLrn()" [disabled]="'btn-disabled' === getBtnExportCsvLrn()" (click)="getSearchByLrn()">Export to CSV</button>
                </div>
            </div>
        </div>

       
    </div>

   
</div>

